import { type BaseApiContract } from "shared/api/BaseApiContract";
import { HttpMethod } from "shared/api/http";
import { type SocietyProfileReviewAssignmentParamsInput } from "shared/api/types/society/[societyId]/profiles/[profileId]/review/assignments/[reviewAssignmentId]";
import { type RecuseAssignmentBodyInput } from "shared/api/types/society/[societyId]/profiles/[profileId]/review/assignments/[reviewAssignmentId]/recuse";
export const patchSocietyProfileReviewAssignmentRecuseContract: BaseApiContract<
  SocietyProfileReviewAssignmentParamsInput,
  RecuseAssignmentBodyInput,
  void
> = {
  method: HttpMethod.PATCH,
  apiRoute:
    "/api/v1/society/[societyId]/profiles/[profileId]/review/assignments/[reviewAssignmentId]/recuse",
  paramsType: {} as SocietyProfileReviewAssignmentParamsInput,
  bodyType: {} as RecuseAssignmentBodyInput,
  responseType: undefined as unknown as void,
};
